export default __webpack_public_path__ + "static/media/6ixer03.32327b48.jpg";